import { Popover } from "@headlessui/react"
import { ReactNode, useRef } from "react"
import { classNames } from "../../utils/classNames"

export interface TooltipProps {
  children: ReactNode
  content: ReactNode
  className?: string
  timeoutDuration?: number
}

export const Tooltip = ({ children, content, className = "", timeoutDuration = 10 }: TooltipProps) => {
  const triggerRef = useRef<any>(null)
  const timeOutRef = useRef<any>(null)

  const handleEnter = (isOpen: boolean) => {
    clearTimeout(timeOutRef.current)
    !isOpen && triggerRef.current?.click()
  }

  const handleLeave = (isOpen: boolean) => {
    timeOutRef.current = setTimeout(() => {
      isOpen && triggerRef.current?.click()
    }, timeoutDuration)
  }

  return (
    <Popover className={classNames("relative", className)}>
      {({ open }) => (
        <div onMouseEnter={() => handleEnter(open)} onMouseLeave={() => handleLeave(open)}>
          <Popover.Button as="div" ref={triggerRef}>
            {children}
          </Popover.Button>
          <Popover.Panel
            transition
            className="absolute left-1/2 z-50 w-fit -translate-x-1/2 transform rounded border bg-white px-2.5 py-1 text-xs font-medium whitespace-nowrap text-gray-500 shadow transition duration-200 ease-out data-[closed]:opacity-0">
            {content}
          </Popover.Panel>
        </div>
      )}
    </Popover>
  )
}
